import React from "react";
import _ from "lodash";
import { NetworkAPI } from "apis";

import ClickToCopyWrapper from "components/common/ClickToCopyWrapper";
import LoadingUI from "components/common/LoadingUI";
import { unitId } from "constants/Unit";

let CACHE_UNITS = {};

class UnitInfo extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      items: [],

      errMsg: null,
      isLoading: false,
    };
  }

  async componentDidMount() {
    try {
      this.setState({ isLoading: true });

      const {
        networkId,
        selectedItems,
        selectMetric = unitId.EXT_GAM_UNIT_ID,
        units,
      } = this.props;
      if (!networkId && !units) {
        throw new Error("Missing Network ID");
      }

      let data = [];
      const unitData = CACHE_UNITS[networkId] || units;
      if (unitData && unitData.length > 0) {
        data = unitData;
      } else {
        data = await NetworkAPI.getUnitsByNetworkId({ networkId });
        CACHE_UNITS[networkId] = data;
        if (!data) {
          throw new Error("Failed to find units");
        }
      }

      const selected = _.orderBy(
        _.map(selectedItems, (item) => {
          return _.find(data, { [selectMetric]: item });
        }).filter((item) => item),
        [(item) => item[selectMetric]],
        ["asc"]
      );

      this.setState({
        items: selected,
        isLoading: false,
      });
    } catch (err) {
      this.setState({
        isLoading: false,
        errMsg: err.toString(),
      });
    }
  }

  render() {
    const { items, isLoading, errMsg } = this.state;

    const extGamUnitIds = _.map(items, (item) => item.extGamUnitId);
    const gamUnitIds = _.map(items, (item) => item.unitId);

    return (
      <div className="relative">
        <div className="flex justify-end gap-1 text-xs text-blue-500">
          <ClickToCopyWrapper
            copyText={extGamUnitIds.join(",")}
            buttonText="Copy Ext Gam Unit IDs"
            place="bottom"
          ></ClickToCopyWrapper>
          <ClickToCopyWrapper
            copyText={gamUnitIds.join(",")}
            buttonText="Copy Unit IDs"
            place="bottom"
          ></ClickToCopyWrapper>
        </div>

        <div>
          {errMsg && <div className="text-red-600">{errMsg}</div>}
          {isLoading && <LoadingUI></LoadingUI>}
        </div>

        {items.length !== 0 && !isLoading && !errMsg && (
          <div
            className="border rounded flex flex-wrap gap-1 overflow-y-auto border-gray-400 bg-gray-100 p-2"
            style={{ maxHeight: "480px" }}
          >
            {items.map((item) => {
              return (
                <div
                  key={item.unitId}
                  className="border break-all bg-gray-300 px-2 text-sm text-gray-800"
                >
                  {item.unitId} {item.name} ({item.extGamUnitId})
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

export default UnitInfo;
